export default "__VITE_ASSET__B8LeFJqD__"